export default __webpack_public_path__ + "static/media/bluedot-logo.c19a38f7.png";